import { $getRoot } from 'lexical';
import { BrandFontRef } from 'modules/BrandDefinition';
import { $getTextNodeStyleValueForProperty, $patchTextNodeStyle } from 'modules/Lexical/lexicalUtils';
import { FontPluginStyle, getStyleObjectForBrandFont } from 'modules/Lexical/Plugins/FontPlugin/style';

import * as Models from 'models';
import { getCharacterStyle } from 'utils/brandStyles';

export const $matchFontNameAndCharacterStyle = (
  fonts: Models.BrandFontsList,
  brandFontName: string,
  brandCharacterStyle: string | undefined,
): string | undefined => {
  let commonFontName = '';
  let areSeveralFontNamesApplied = false;
  let styleObjectForBrandFont: Record<string, string | null>;

  $getRoot().getAllTextNodes().forEach((node, index) => {
    const currentFontName = $getTextNodeStyleValueForProperty(node, FontPluginStyle.BRAND_FONT_NAME, '');
    const currentCharacterStyle = $getTextNodeStyleValueForProperty(node, FontPluginStyle.BRAND_FONT_CHARACTER_STYLE_NAME, '');

    const currentFont = fonts.find(font => font?.get('name') === currentFontName);
    const currentCharacterStyles = currentFont && currentFont.get('characterStyles');

    const currentCharacterStyleExists = currentCharacterStyle &&
    currentCharacterStyles?.some(characterStyle => characterStyle?.get('name') === currentCharacterStyle);
    const characterStyleFallback = !currentCharacterStyleExists && getCharacterStyle(currentCharacterStyles);

    if (currentFont) {
      const isBrandFontApplied = currentFontName === brandFontName;

      if (isBrandFontApplied && currentCharacterStyles && currentCharacterStyles.size > 0 && !currentCharacterStyleExists) {
        if (brandCharacterStyle) {
          const fontRef: BrandFontRef = {
            fontName: currentFontName,
            characterStyleName: brandCharacterStyle,
          };
          styleObjectForBrandFont = getStyleObjectForBrandFont(fonts, fontRef);
        } else if (characterStyleFallback) {
          const fontRef: BrandFontRef = {
            fontName: currentFontName,
            characterStyleName: characterStyleFallback.get('name'),
          };
          styleObjectForBrandFont = getStyleObjectForBrandFont(fonts, fontRef);
        }
      }

      if (!isBrandFontApplied && !currentCharacterStyleExists && characterStyleFallback) {
        const fontRef: BrandFontRef = {
          fontName: currentFontName,
          characterStyleName: characterStyleFallback.get('name'),
        };
        styleObjectForBrandFont = getStyleObjectForBrandFont(fonts, fontRef);
      }
    } else {
      const fontRef: BrandFontRef = {
        fontName: brandFontName,
        characterStyleName: brandCharacterStyle,
      };
      styleObjectForBrandFont = getStyleObjectForBrandFont(fonts, fontRef);
    }

    // save first font family style for further detecting whether multiple font families applied
    if (index === 0) {
      commonFontName = currentFontName;
    } else if (!areSeveralFontNamesApplied && currentFontName !== commonFontName) {
      areSeveralFontNamesApplied = true;
    }

    if (styleObjectForBrandFont) {
      $patchTextNodeStyle(node, styleObjectForBrandFont);
    }
  });

  return areSeveralFontNamesApplied ? undefined : commonFontName;
};
